export default __webpack_public_path__ + "static/media/18.5725e7a6.webp";